module.exports = __webpack_public_path__ + "static/media/14285605051650951397AVK01781.82da77b7.jpg";